/**
 * Generate personalized conversation starters based on user context
 */
export function generateConversationStarters(family, experiences = []) {
  const starters = [];
  
  // Get active experiences
  const activeExperiences = experiences.filter(exp => 
    exp.currentPhase && exp.status !== 'completed' && exp.status !== 'archived'
  );

  // Get kids ages
  const kidsAges = family?.kids?.map(k => k.age) || [];
  const youngestAge = kidsAges.length > 0 ? Math.min(...kidsAges) : null;

  // 1. Based on active experiences
  activeExperiences.forEach(exp => {
    const expData = exp;
    const daysUntil = expData.date 
      ? Math.ceil((expData.date.toDate ? expData.date.toDate() : new Date(expData.date) - new Date()) / (1000 * 60 * 60 * 24))
      : null;

    if (expData.currentPhase === 'exposure') {
      starters.push({
        prompt: `Help me choose a style for my ${expData.title || 'celebration'}`,
        icon: '💡',
        experienceId: exp.id,
      });
    }

    if (daysUntil !== null && daysUntil < 14 && expData.currentPhase !== 'execution') {
      starters.push({
        prompt: `My ${expData.title || 'celebration'} is in ${daysUntil} days - help me finalize plans`,
        icon: '⏰',
        experienceId: exp.id,
      });
    }
  });

  // 2. Based on kids ages
  if (youngestAge !== null) {
    starters.push({
      prompt: `What's a good Jewish activity for a ${youngestAge}-year-old?`,
      icon: '🎨',
    });
  }

  // 3. Based on upcoming holidays (simplified - could use Hebrew calendar)
  const now = new Date();
  const month = now.getMonth() + 1; // 1-12
  
  // Passover (March-April)
  if (month === 3 || month === 4) {
    starters.push({
      prompt: 'Help me plan a Passover seder that my kids will enjoy',
      icon: '🎉',
    });
  }
  
  // Hanukkah (November-December)
  if (month === 11 || month === 12) {
    starters.push({
      prompt: 'What are some meaningful Hanukkah traditions for families?',
      icon: '🕎',
    });
  }

  // 4. General starters if we don't have enough
  if (starters.length < 3) {
    starters.push({
      prompt: 'Help me plan a Shabbat dinner that feels special but not overwhelming',
      icon: '🕯️',
    });
  }

  if (starters.length < 3) {
    starters.push({
      prompt: 'What are some simple ways to bring Jewish traditions into our daily life?',
      icon: '✨',
    });
  }

  return starters.slice(0, 5); // Return max 5 starters
}

